import { differenceInDays, getTimestamp, DisplayDate } from 'owa-datetime';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { createMonthDateRange } from 'owa-datetime-utils';

/**
 * Calculate the week index that the given date falls in for a standard month view
 * @param store The surface store
 * @param date The date
 * @returns The week index from the beggining of the current display range.
 */
export default function calculateWeekIndexFromDate(
    store: CalendarSurfaceStore,
    date: DisplayDate
): number {
    let monthDateRange = createMonthDateRange(
        store.dateRange.start,
        store.userOptions.weekStartDay
    );
    let monthStart = monthDateRange.start;
    let monthEnd = monthDateRange.end;
    let weeksInMonth = differenceInDays(monthEnd, monthStart) / TimeConstants.DaysInOneWeek;

    let datesDeltaInMs = getTimestamp(date) - getTimestamp(monthStart);
    let datesDeltaInDays = datesDeltaInMs / TimeConstants.MillisecondsInOneDay;
    let weekIndex = Math.floor(datesDeltaInDays / TimeConstants.DaysInOneWeek);
    if (weekIndex > weeksInMonth || weekIndex < 0) {
        weekIndex = -1;
    }
    return weekIndex;
}
